import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TermsContent } from '../../common/TermsInfo';
import TermsAgreementText from './TermsAgreementText';

const TermsModal = ({ setTcAgree, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      visible
      centered
      onCancel={onClose}
      footer={null}
      width={390}
      className="terms-modal"
      title={t('checkout.termsConditions')}
    >
      <div className="terms-modal__body">
        <TermsContent />
      </div>
      <p className="terms-modal__agree-text">
        <TermsAgreementText />
      </p>
      <button
        type="button"
        className="terms-modal__agree-button"
        onClick={() => {
          setTcAgree(true);
          onClose();
        }}
      >
        {t('singlePageCheckout.agreeToTerms')}
      </button>
    </Modal>
  );
};

TermsModal.propTypes = {
  tcAgree: PropTypes.bool,
  setTcAgree: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default TermsModal;
